// ContentCard component with image, fallback icon, and linking capability
import ImageIcon from '@mui/icons-material/Image';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export function ContentCard({ title, imageUrl, linkPath }) {
  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      lg={3}
    >
      <Box
        component={RouterLink}
        to={linkPath}
        sx={{
          height: 150,
          backgroundColor: '#f0f0f0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: 2,
          textAlign: 'center',
          position: 'relative',
          textDecoration: 'none',
          color: 'inherit',
          overflow: 'hidden',
          '&:hover': {
            boxShadow: 3,
          },
        }}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={title}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              borderRadius: 'inherit',
              objectFit: 'cover',
              width: '100%',
              height: '100%',
              display: 'block',
              transition: 'transform 0.3s ease',
            }}
          />
        ) : (
          <ImageIcon sx={{ fontSize: 60, color: '#ccc' }} />
        )}
        <Typography
          variant="body1"
          sx={{
            position: 'absolute',
            bottom: 8,
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            color: 'white',
            padding: '2px 8px',
            borderRadius: 1,
          }}
        >
          {title}
        </Typography>
      </Box>
    </Grid>
  );
}
